import { combineReducers } from 'redux';
import AddNewsReducer from './AddNewsReducer';
import AddSolutionReducer from './AddSolutionReducer';
import AddTaskReducer from './AddTaskReducer';
import CorrectSolutionReducer from './CorrectSolutionReducer';
import EditNewsReducer from './EditNewsReducer';
import EditTaskReducer from './EditTaskReducer';
import EventReducer from './EventReducer';
import GroupsReducer from './GroupsReducer';
import HomeworksReducer from './HomeworksReducer';
import ImagesReducer from './ImagesReducer';
import MentorsReducer from './MentorsReducer';
import NewsReducer from './NewsReducer';
import NoteReducer from './NoteReducer';
import TraineeReducer from './TraineeReducer';
import UserReducer from './UserReducer';

const rootReducer = combineReducers({
  user: UserReducer,
  news: NewsReducer,
  newNews: AddNewsReducer,
  selectedNews: EditNewsReducer,
  homeworks: HomeworksReducer,
  correction: CorrectSolutionReducer,
  newTask: AddTaskReducer,
  selectedTask: EditTaskReducer,
  newSolution: AddSolutionReducer,
  events: EventReducer,
  trainees: TraineeReducer,
  notes: NoteReducer,
  groups: GroupsReducer,
  mentors: MentorsReducer,
  images: ImagesReducer,
});

export default rootReducer;
